import React from 'react';
import MiniPlayer from '../components/MiniPlayer.jsx';
import Code from '../components/Code.jsx';
import { bonesDoc } from '../scenes/minis.js';
import puppetScript from '../scripts/puppet.script.json';
import puppetSource from '../scripts/puppet.ts?raw';

export default function BonesSection() {
  return (
    <section className="sec" id="bones" aria-labelledby="bones-h">
      <div className="wrap">
        <header className="sec-head">
          <p className="kicker">Bones and IK</p>
          <h2 id="bones-h">Skeletons for symbols, and shapes skinned to bones.</h2>
          <p className="sec-lead">
            Bones as data: an armature of bones with limits, symbols bound rigidly to them,
            shapes skinned with automatic weights, keyed rotations (forward kinematics) and keyed IK targets.
            Here the figure&rsquo;s hand is keyed to wave; move the pointer over the stage and a short
            script drives the same bone by IK instead.
          </p>
        </header>
        <div className="split">
          <div className="split-demo">
            <MiniPlayer
              build={(Pulse) => bonesDoc(Pulse, puppetScript)}
              label="Bones demo: a figure whose arm reaches for the pointer by inverse kinematics, and a tube shape bent by four bones"
              options={{ scripts: true }}
            />
            <p className="demo-cap">Left: rigid rig, nine symbols on nine bones. Right: one tube shape skinned to four bones.</p>
          </div>
          <div className="split-code">
            <div className="code-tab"><span>puppet.ts</span></div>
            <Code label="The puppet script">{puppetSource}</Code>
            <div className="code-tab"><span>the rig, with the Builder</span></div>
            <Code label="Building an armature with the Builder">{`const arm = d.armature('figure');
arm.bone('spine', { x: 440, y: 490, length: 170, angle: -90 });
arm.bone('r_up',  { parent: 'spine', x: 470, y: 350, length: 110, angle: -20 });
arm.bone('r_fore', { parent: 'r_up', length: 100, angle: -70, limits: { min: -150, max: 10 } });
arm.bone('r_hand', { parent: 'r_fore', length: 36, angle: -70, ik: { chain: 3 } });
arm.bind('armR1', 'r_up');                        // a symbol instance rides a bone
arm.target('r_hand', Pulse.keys(...wave));        // keyed IK target
tube.skin('tube', { influences: 2, smooth: 2 });  // automatic weights`}</Code>
          </div>
        </div>
      </div>
    </section>
  );
}
